<template>
  <v-app>
    <v-main class="d-flex flex-column pnel_main_class">
      <Main></Main>
    </v-main>
  </v-app>
</template>

<script>
import Main from "./components/MainPage.vue";

export default {
  name: "App",

  components: {
    Main,
  },
};
</script>
<style scoped>
.pnel_main_class {
  height: 100dvh;
}
@media screen and (max-width: 959.98px) {
  .pnel_main_class {
    height: auto;
  }
}
</style>
